import BrandIconURL from '../assets/img/jade_logo.png';
import AppIconURL from '../assets/img/jade_logo_new.png';

export const DOMAIN_NAME = 'FIDUCIAL_JADE';
export const API_DOMAIN_NAME = DOMAIN_NAME;

export const BRAND_NAME = 'Jade Fiducial';
export const PRODUCT_NAME = 'Client Portal';
export const APP_MENU_ICON_URL = BrandIconURL;
export const APP_EXPLORE_ICON_URL = AppIconURL;

export const LOGIN_BRAND_LOGO = {
    width: '240px'
};

export const PORTAL_URL = process.env.REACT_APP_JADE_PORTAL_URL ?? 'JADE_URL';

export const APP_MENU_ICON_PROPS = {};
export const APP_EXPLORE_ICON_CONF = {
    backgroundImage: `url(${APP_EXPLORE_ICON_URL})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 310,
    width: 310,
    margin: 14
};

export default {
    DOMAIN_NAME,
    BRAND_NAME,
    PRODUCT_NAME,
    APP_MENU_ICON_URL,
    APP_MENU_ICON_PROPS,
    LOGIN_BRAND_LOGO,
    PORTAL_URL,
    APP_EXPLORE_ICON_URL,
    APP_EXPLORE_ICON_CONF,
};
